import { render, staticRenderFns } from "./CoreLayoutHeadlineWithTabs.vue?vue&type=template&id=1cf7530f&scoped=true"
import script from "./CoreLayoutHeadlineWithTabs.vue?vue&type=script&lang=js"
export * from "./CoreLayoutHeadlineWithTabs.vue?vue&type=script&lang=js"
import style0 from "./CoreLayoutHeadlineWithTabs.vue?vue&type=style&index=0&id=1cf7530f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7530f",
  null
  
)

export default component.exports